import { j as jsxRuntimeExports } from './../../../../../ext/react/jsx-runtime.js';
import { Base } from '../../../Internal/Base/Base.js';

const pathStrings = {
    24: [
        'M7.385 18.752L12 15.462l4.615 3.29-1.704-5.408 4.543-3.343h-5.678L12 4.6 10.224 10H4.546l4.543 3.343-1.704 5.408zm-.451 2.778c-1.234.879-2.507-.045-2.051-1.49l1.868-5.933-5.03-3.702C.501 9.508.976 8 2.496 8h6.28l1.961-5.966c.475-1.442 2.053-1.431 2.524 0L15.224 8h6.279c1.53 0 1.994 1.508.777 2.404l-5.031 3.702 1.868 5.933c.455 1.444-.816 2.37-2.05 1.49L12 17.918 6.934 21.53z',
    ],
};
const IconStarOutline = ({ size, className, ...rest }) => {
    const paths = pathStrings[size].map((d, i) => (jsxRuntimeExports.jsx("path", { d: d, fillRule: "evenodd" }, String(i))));
    return (jsxRuntimeExports.jsx(Base, { as: "svg", height: size, width: size, viewBox: `0 0 ${size} ${size}`, className: className, xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", preserveAspectRatio: "xMidYMid meet", fill: "currentColor", ...rest, children: paths }));
};
IconStarOutline.displayName = 'IconStarOutline';

export { IconStarOutline };
//# sourceMappingURL=IconStarOutline.js.map
